import { render } from "./DataConnections.vue?vue&type=template&id=33f2e624&scoped=true"
import script from "./DataConnections.vue?vue&type=script&lang=js"
export * from "./DataConnections.vue?vue&type=script&lang=js"

import "./DataConnections.vue?vue&type=style&index=0&id=33f2e624&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f2e624"]])

export default __exports__